import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-03489404")

_pushScopeId("data-v-03489404")
const _hoisted_1 = { class: "auth-nav" }
const _hoisted_2 = {
  key: 0,
  class: "auth-nav__list"
}
const _hoisted_3 = { class: "auth-nav__item" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 회원가입 ")
const _hoisted_5 = { class: "auth-nav__item" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "로그인", -1)
const _hoisted_7 = {
  key: 1,
  class: "auth-nav__list"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 마이페이지 ")
const _hoisted_9 = { class: "auth-nav__item" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "로그아웃", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("nav", _hoisted_1, [
      (!_ctx.name)
        ? (_openBlock(), _createBlock("ul", _hoisted_2, [
            _createVNode("li", _hoisted_3, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.RouterName.SIGNUP }
              }, {
                default: _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createVNode("li", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.RouterName.SIGNIN },
                class: "-button"
              }, {
                default: _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]))
        : (_openBlock(), _createBlock("ul", _hoisted_7, [
            _createVNode("li", {
              class: 
            _ctx.isActive('/mypage') ? 'auth-nav__item -active' : 'auth-nav__item'
          
            }, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.RouterName.PROFILE }
              }, {
                default: _withId(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["to"])
            ], 2),
            _createVNode("li", _hoisted_9, [
              _createVNode("a", {
                class: "-button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
              }, [
                _hoisted_10
              ])
            ])
          ]))
    ])
  ]))
})